import axios from "axios";
const apiUrl = window._env_?.REACT_APP_BACKEND_URL;
const nodeApiUrl = "http://localhost:5001/api/";
const api = axios.create({
    baseURL: apiUrl,
    validateStatus: (status) => status >= 200 && status < 300,
});


export const nodeApi = axios.create({
    baseURL: nodeApiUrl,
    validateStatus: (status) => status >= 200 && status < 300,
});

export default api;
